<fieldset [formGroup]="form" class="in-one-column w-100">
  <legend>
    {{ title ?? "SHARED.LOCALIZED_SEO_SUBFORM.TITLE" | translate }}:
  </legend>

  <ng-container *ngFor="let key of getKeys(); let i = index">
    <!-- míg nem kell fordítani legyen kikommentezve -->

    <!--span class="padded-bottom"> {{ getNameByCode(key) | titlecase }}</span-->

    <div [formGroupName]="key" class="in-two-columns">
      <mat-form-field>
        <app-easy-input
          [label]="'SHARED.LOCALIZED_SEO_SUBFORM.FRIENDLY_URL' | translate"
          formControlName="friendlyUrl"
        ></app-easy-input>
      </mat-form-field>

      <mat-form-field>
        <app-easy-input
          [label]="'SHARED.LOCALIZED_SEO_SUBFORM.META_TITLE' | translate"
          formControlName="metaTitle"
        ></app-easy-input>
      </mat-form-field>

      <mat-form-field>
        <app-easy-input
          [label]="'SHARED.LOCALIZED_SEO_SUBFORM.META_DESCRIPTION' | translate"
          formControlName="metaDescription"
        ></app-easy-input>
      </mat-form-field>

      <mat-form-field [formGroup]="metaInputs">
        <label>
          {{ "SHARED.LOCALIZED_SEO_SUBFORM.META_TAGS" | translate }}
        </label>
        <input
          class="mb-3"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="addTag($event, key)"
          [matChipInputAddOnBlur]="true"
        />
        <mat-chip-grid #chipList [formControlName]="key">
          <mat-chip
            class="easy-chip"
            *ngFor="let tag of metaTags[key]"
            (removed)="removeTag(tag, key)"
            [attr.aria-readonly]="readOnly"
          >
            {{ tag }}
            <button type="button" matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        </mat-chip-grid>
      </mat-form-field>
    </div>

    <!-- míg nem kell fordítani legyen kikommentezve -->

    <!--button
    type="button"
    mat-icon-button
    color="primary"
    class="padded-bottom"
    (click)="onDelete(key)"
    *ngIf="!readOnly"
  >
    <mat-icon>delete</mat-icon>
  </button-->
  </ng-container>
</fieldset>

<!-- míg nem kell fordítani legyen kikommentezve -->

<!--ng-container *ngIf="!readOnly">
  <button type="button" mat-icon-button color="primary" (click)="onAdd()">
    <mat-icon>add</mat-icon>
  </button>

  <app-select-search
    [control]="languageSelect"
    [items]="getLanguages()"
    [equalsFunction]="equalsFunction"
    [matchFunction]="matchFunction"
    [nameFunction]="nameFunction"
  >
  </app-select-search>
</ng-container-->
